import { FileText, Zap, LifeBuoy, ShieldCheck } from "lucide-react";

const ITEMS = [
  {
    title: "No Long-Term Contract",
    desc: "Simple month-to-month service.",
    Icon: FileText,
  },
  {
    title: "Fast Turnaround",
    desc: "Typical timelines are confirmed after we receive your business information and content.",
    Icon: Zap,
  },
  {
    title: "Ongoing Support",
    desc: "We're available when you need reasonable website updates or help.",
    Icon: LifeBuoy,
  },
  {
    title: "Secure Hosting",
    desc: "Modern hosting and SSL protection included.",
    Icon: ShieldCheck,
  },
];

export const ValueStrip = () => {
  return (
    <section
      className="bg-white border-y border-goc-border"
      aria-label="Why Get Online Crew"
      data-testid="section-value-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {ITEMS.map(({ title, desc, Icon }) => (
            <li
              key={title}
              className="flex items-start gap-4"
              data-testid={`value-item-${title
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")}`}
            >
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-goc-primary/10 text-goc-primary shrink-0">
                <Icon className="h-5 w-5" strokeWidth={2.25} />
              </span>
              <div>
                <h3 className="text-base font-semibold text-goc-text">
                  {title}
                </h3>
                <p className="mt-1 text-sm text-goc-muted leading-relaxed">
                  {desc}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ValueStrip;
